module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_donation02-c44f23d6bc5410ddace413c910323c95.jpg";